/**
 * Admin toolbar — floating panel with change counter and Save to Disk button.
 */
import { getCountries, getDirtyCount, clearDirty } from './state';
import { saveCountriesToServer } from './export';

let badgeEl: HTMLElement | null = null;
let statusEl: HTMLElement | null = null;

export function initAdminToolbar(): void {
  const toolbar = document.createElement('div');
  toolbar.id = 'admin-toolbar';
  toolbar.innerHTML = `
    <span class="admin-toolbar-label">ADMIN</span>
    <span class="admin-toolbar-badge" id="admin-badge">0 changes</span>
    <button class="admin-toolbar-save" id="admin-save-btn">💾 Save Changes</button>
    <span class="admin-toolbar-status" id="admin-status"></span>
  `;
  document.body.appendChild(toolbar);

  badgeEl = document.getElementById('admin-badge');
  statusEl = document.getElementById('admin-status');

  document.getElementById('admin-save-btn')!.addEventListener('click', handleSave);
}

export function updateToolbarBadge(): void {
  if (badgeEl) {
    const count = getDirtyCount();
    badgeEl.textContent = `${count} change${count !== 1 ? 's' : ''}`;
    badgeEl.classList.toggle('has-changes', count > 0);
  }
}

async function handleSave(): Promise<void> {
  const btn = document.getElementById('admin-save-btn') as HTMLButtonElement;
  btn.disabled = true;
  btn.textContent = 'Saving...';
  showStatus('');

  const result = await saveCountriesToServer(getCountries());

  btn.disabled = false;
  btn.textContent = '💾 Save Changes';

  if (result.ok) {
    clearDirty();
    updateToolbarBadge();
    showStatus('Saved!', 'success');
  } else {
    showStatus(`Error: ${result.message}`, 'error');
  }
}

function showStatus(msg: string, type?: 'success' | 'error'): void {
  if (!statusEl) return;
  statusEl.textContent = msg;
  statusEl.className = 'admin-toolbar-status';
  if (type) statusEl.classList.add(type);

  if (msg) {
    setTimeout(() => {
      if (statusEl) {
        statusEl.textContent = '';
        statusEl.className = 'admin-toolbar-status';
      }
    }, 3000);
  }
}
